import { authorizedFetch } from '../../helpers/authorizedFetch'
import trans from '../../helpers/trans'
import { generateApiUrl } from '../../helpers/url'
import isResourceCollectionDocument from '../../japi/guards/isResourceCollectionDocument'
import { JapiDocument } from '../../japi/types/Document'
import { FetchCollectionResult, FetchResultType } from '../FetchResult'
import { DashboardSetting, DashboardSettingResource } from './DashboardSetting'
import { transformResourceToDashboardSetting } from './DashboardSettingTransformers'

export const getDashboardSettingsApiCall = async (): Promise<FetchCollectionResult<DashboardSetting[], string>> => {
    try {
        const url = generateApiUrl({
            endpoint: '/dashboard-settings',
        })

        const response = await authorizedFetch(url)

        const doc: JapiDocument = await response.json()

        if (! isResourceCollectionDocument<DashboardSettingResource>(doc) || ! doc.data) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const dashboardSettings = doc.data.map(transformResourceToDashboardSetting)

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data: dashboardSettings,
        }
    } catch (error) {
        console.error('[getDashboardSettingsApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
